import { green } from "@ant-design/colors"

type Props = {
  isChildWorkarea?: boolean
}

const HighlightIndicator = ({ isChildWorkarea }: Props) => {
  return <div
    style={{
      marginLeft: isChildWorkarea ? '54px' : '0',
      height: '3px',
      backgroundColor: green.primary,
      borderRadius: '2px',
      zIndex: 1000,
      transition: 'top 0.2s ease-in-out'
    }}
  />
}

export default HighlightIndicator